import { createReducer, on } from '@ngrx/store';
import * as ConfigActions from '@app/store/features/config/config.actions';
import { SkinSettings } from '@app/models/skin-settings';
import { GlobalSettings } from '@app/models/global-settings';
import { JackPotInfo } from '@app/models/jackpot-info';
import { DomainSettings } from '@app/models/domain-settings';
import { EmoticonInfo } from '@app/models/emoticon-info';

interface LocalConfig {
    assetsLoaded: boolean;
    gameInitialized: boolean;
}

export enum CardSize {
    normal = 0,
    large = 1,
    extraLarge = 2
}

export interface ConfigTheme {
    card: number;
    backCard: number;
    table: number;
    carpet: number;
    playerCardSize: CardSize;
}

export interface AuthSettings {
    token: string;
    url: string;
    username: string;
    password: string;
}

export interface State extends LocalConfig {
    emoticonsInfo: EmoticonInfo[]; // will be reacived from the server after the login

    casinosInfo: any[];  // will be reacived from the server after the login
    jackPotsInfo: JackPotInfo[];  // will be reacived from the server after the login
    appReadyToUse: boolean; // will be reacived from the server after the login
    globalSettings: GlobalSettings | null; // mostly used for the game
    skinSettings: SkinSettings | null; // (firebase) will be reacived from the server after the login
    domainSettings: DomainSettings | null; // creator configuration for domainname
    authSettings: AuthSettings | null; // REST API Config
    assets: {
        default: {
            loaded: number;
        },

        //  later extandable with themes
        theme: ConfigTheme
    }
}

export const initialState: State = {
    emoticonsInfo: [],

    casinosInfo: [],
    jackPotsInfo: [],

    appReadyToUse: false,



    globalSettings: null,
    skinSettings: null,
    authSettings: null,

    domainSettings: null,
    assetsLoaded: true,
    gameInitialized: false,

    assets: {
        default: {
            loaded: 0
        },
        theme: {
            card: 0, // CardStyle ID
            backCard: 0, // BackCardStyle ID
            table: 0, // TableStyle ID
            carpet: 0, // TableStyle ID,
            playerCardSize: CardSize.normal
        }
    }
};

export const reducer = createReducer(
    initialState,
    on(ConfigActions.updateAppReadyToUse, (state, { appReadyToUse }) => ({ ...state, appReadyToUse })), // CODE_DEBT: gameInitialized is set to appReadyToUse
    on(ConfigActions.updateGameInitialized, (state, { gameInitialized }) => ({ ...state, gameInitialized })),
    on(ConfigActions.updateGlobalSettings, (state, { globalSettings }) => ({ ...state, globalSettings })),
    on(ConfigActions.updateSkinSettings, (state, { skinSettings }) => ({ ...state, skinSettings })),

    on(ConfigActions.updateCasinosInfo, (state, { casinosInfo }) => ({ ...state, casinosInfo })),
    on(ConfigActions.updateJackPotsInfo, (state, { jackPotsInfo }) => ({ ...state, jackPotsInfo })),
    on(ConfigActions.updateEmoticonsInfo, (state, { emoticonsInfo }) => ({ ...state, emoticonsInfo })),

    on(ConfigActions.updateDomainSettings, (state, { domainSettings }) => ({ ...state, domainSettings })),
    on(ConfigActions.updateAuthSettings, (state, { authSettings }) => ({ ...state, authSettings })),

    on(ConfigActions.onAssetsLoading, (state, { percentage }) => {
        const assets = { ...state.assets, default: { loaded: percentage } };
        return { ...state, assets }
    }),

    // theme
    on(ConfigActions.updateAssetsThemeSelectCard, (state, { id }) => {
        const theme = { ...state.assets.theme, card: id };
        const assets = { ...state.assets, theme };

        return { ...state, assets }
    }),

    on(ConfigActions.updateAssetsThemeSelectBackCard, (state, { id }) => {
        const theme = { ...state.assets.theme, backCard: id };
        const assets = { ...state.assets, theme };

        return { ...state, assets }
    }),

    on(ConfigActions.updateAssetsThemeSelectTable, (state, { id }) => {
        const theme = { ...state.assets.theme, table: id };
        const assets = { ...state.assets, theme };

        return { ...state, assets }
    }),

    on(ConfigActions.updateAssetsThemeSelectCarpet, (state, { id }) => {
        const theme = { ...state.assets.theme, carpet: id };
        const assets = { ...state.assets, theme };
        return { ...state, assets }
    }),

    on(ConfigActions.updateAssetsThemeSelectPlayerCardSize, (state, { size }) => {
        const theme = { ...state.assets.theme, playerCardSize: size };
        const assets = { ...state.assets, theme };
        return { ...state, assets }
    })
);